import React from 'react';
export function CustomMenuIcon({ size = 22 }) {
    return (
        <svg
            width={size}
            height={Math.round(size * 0.75)}
            viewBox="0 0 24 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ display: 'block' }}
        >
            {/* Top Bar (Cyan / Teal) */}
            <rect x="1" y="1" width="22" height="4" rx="2" fill="#06b6d4" />
            {/* Middle Bar (Cyan / Teal) */}
            <rect x="1" y="7" width="22" height="4" rx="2" fill="#06b6d4" />
            {/* Bottom Bar (Dark Navy / Slate) */}
            <rect x="1" y="13" width="22" height="4" rx="2" fill="#334155" />
        </svg>
    );
}
